import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 280;

export const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        // zIndex represents the stack order
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerTitle: {
        paddingTop: 6,
    },
    drawerNotifications: {
        marginLeft: 40,
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    themeSwitch: {
        position: 'fixed',
        right: 40,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    drawerList: {
        padding: 10
    },
    settingsPanel: {
        position: 'absolute',
        bottom: 0,
        width: '100%'
    },
    link: {
        textDecoration: 'none',
        color: 'inherit'
    },
    cameraPopover: {
        padding: theme.spacing(2),
    }
}));

/* CANVAS & VIDEO */
const rootWidth = 660;

export const cardStyles = makeStyles((theme) => ({
    root: {
        width: rootWidth,
        height: 500,
    },
    canvas: {
        position: "absolute",
        margin: 10,
        left: 0,
        right: 0,
        textAlign: "center",
        width: 640,
        height: 480,
    },
    media: {
        height: 350,
    },
    camPermissions: {
        zIndex: 10,
        width: 350,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginTop: 200,
    },
    link: {
        color: theme.palette.primary.main
    }
}));

export const recordStyles = makeStyles((theme) => ({
    recordingButtons: {
        marginBottom: 20
    },
    recordingChip: {
        position: 'absolute',
        right: 0,
        marginTop: 20,
        marginRight: 20,
        zIndex: 9
    },
    rectChip: {
        position: 'absolute',
        left: 0,
        marginTop: 20,
        marginLeft: 20,
        zIndex: 9
    },
    progress: {
        width: rootWidth,
    },
    countdown: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginTop: '35%',
        zIndex: 9,
        width: 85,
        height: 85,
        fontSize: 60,
        backgroundColor: theme.palette.primary.main
    }
}));


export const visualizerStyles = makeStyles((theme) => ({
    visualizerButtons: {
        marginBottom: 20
    },
}));

export const visualControlStyles = makeStyles((theme) => ({
    cButtons: {
        position: 'absolute',
        zIndex: 9,
    }
}));